import(/* webpackMode: "eager" */ "D:\\wORK\\enjoyable\\.enjoyabledesign\\enjoyabledesign\\enjoyabledesign\\src\\app\\about\\portfolio\\blondhaus\\page.tsx");
